export default {
  install(Vue) {
    Vue.prototype.$config = Object.freeze({
      SITECODE_OGAUC: "ogauc", //오클랜드
      SITECODE_OGCBD: "ogcbd", //캄보디아
      SITECODE_OGHK: "oghk", //홍콩
      SITECODE_OGHCM: "ogvtn", //베트남
      SITECODE_OGLD: "ogld", //런던
      SITECODE_OGMMR: "ogmmr", //미얀마
      SITECODE_OGIND: "ogind", //인도
      SITECODE_OGTK: "ogtk", //일본

      OPER_GROUP_CD_OGAUC: "NZ1", //오클랜드
      OPER_GROUP_CD_OGCBD: "KH1", //캄보디아
      OPER_GROUP_CD_OGHK: "HK1", //홍콩
      OPER_GROUP_CD_OGHCM: "VN1", //베트남
      OPER_GROUP_CD_OGLD: "GB1", //런던
      OPER_GROUP_CD_OGMMR: "MM2", //미얀마
      OPER_GROUP_CD_OGIND: "IN1", //인도
      OPER_GROUP_CD_OGTK: "JP1", //일본

      LANG_KOR: "KOR",
      LANG_ENG: "ENG",
      LANG_JPN: "JPN",
      LANG_VTM: "VNM",
      LANG_CAM: "KHM",
      LANG_MMR: "MMR",

      CNCYCD_USD: "USD",
      CNCYCD_MMK: "MMK",
      CNCYCD_ITL: "ITL",
      CNCYCD_ESP: "ESP",
      CNCYCD_JPY: "JPY",
      CNCYCD_INR: "INR",
      CNCYCD_KRW: "KRW",
      CNCYCD_VND: "VND",
      CNCYCD_KHR: "KHR",
      CNCYCD_AUD: "AUD",
      CNCYCD_EUR: "EUR",
      CNCYCD_GBP: "GBP",
      CNCYCD_NZD: "NZD",
      CNCYCD_HKD: "HKD",

      ANDROID_APP_RECENT_VERSION: "2.6.3",
      IOS_APP_RECENT_VERSION: "2.2.2",

      IS_YN_Y: "Y",
      IS_YN_N: "N",

      CALENDAR_TYPE_A: "A", //달력타입(A)
      DATE_SEP: ".", // Date 구분자
      DATE_SEP2: "/", // Date 구분자
      TIME_SEP: ":", // Time 구분자
      MASKING_WORD: "*", //마스킹처리 문자
      NO_MASK_EMAIL_ARR: ["webmaster"], //webmaster와 같은 이메일주소 아이디부분 마스킹 비처리대상

      API_HOST: "http://10.2.20.13:8089",

      BOPRDCTCD_ODEPS2: "01001", // BO상품코드(앞4자리)-보통예금
      BOPRDCTCD_ODEPS: "01002", // BO상품코드(앞4자리)-보통예금
      BOPRDCTCD_CHKAC: "01003", // BO상품코드(앞4자리)-당좌예금
      BOPRDCTCD_FXDEP: "02001", // BO상품코드(앞4자리)-정기예금
      BOPRDCTCD_TMDEP: "03001", // BO상품코드(앞4자리)-정기적금
      BOPRDCTCD_CALL: "01006", // BO상품코드(앞4자리)-콜예금

      BOPRDCTCD_ODEPS_ASIS: "5001", // BO상품코드(앞4자리)-보통예금
      BOPRDCTCD_CHKAC_ASIS: "5002", // BO상품코드(앞4자리)-당좌예금
      BOPRDCTCD_FXDEP_ASIS: "5101", // BO상품코드(앞4자리)-정기예금
      BOPRDCTCD_TMDEP_ASIS: "5201", // BO상품코드(앞4자리)-정기적금

      USERTYPE_PPSN: "1", //개인
      USERTYPE_CORP: "2", //법인

      OS_IOS: "1", //IOS
      OS_ANDROID: "2", //안드로이드

      WWW_JOIN_N_0: "0", //영업점 가입만 가능
      WWW_JOIN_Y_1: "1", //인스뱅 가입 가능
      WWW_JOIN_Y_2: "2", //인뱅 가입 전용
      WWW_JOIN_Y_3: "3", //스타뱅킹 가입 전용

      OBAOB_DSTCD_1: "1", //당행
      OBAOB_DSTCD_2: "2", //타행

      AUTO_LOGOUT_TIMER: 59, //자동로그아웃 처리 대기 시간

      AUTH_01: "01", //일반인증 - ADV(RO) 인증
      AUTH_02: "02", //간편+일반 이체인증
      AUTH_03: "03", //비로그인 일반인증
      AUTH_04: "04", //일반인증 - ADV(CR) 인증
      AUTH_05: "05", //인증없음(인증생략)

      SCURTY_DEVI_VNDR_DSTCD_000: "", // 해당무
      SCURTY_DEVI_VNDR_DSTCD_004: "004", // 바스코(tokenOTP)
      SCURTY_DEVI_VNDR_DSTCD_701: "701", // 센스톤(mOTP)
      SCURTY_DEVI_VNDR_DSTCD_304: "304", // 바스코(advancedOTP)
      SCURTY_DEVI_VNDR_DSTCD_FIDO_PINCODE: "PINCODE", // FIDO(PINCODE)
      SCURTY_DEVI_VNDR_DSTCD_FIDO_FINGERPRINT: "FINGERPRINT", // FIDO(FINGERPRINT)
      SCURTY_DEVI_VNDR_DSTCD_304RO: "304RO", // 바스코(AdvancedOTP): RO
      SCURTY_DEVI_VNDR_DSTCD_304CR: "304CR", // 바스코(AdvancedOTP): CR
      SCURTY_DEVI_VNDR_DSTCD_NON_CERTN: "NON_CERTN", // 인증패스.

      CORP_BZWK_APRVALCD_110010: "110010", //계좌간이체
      CORP_BZWK_APRVALCD_110020: "110020", //다계좌이체
      CORP_BZWK_APRVALCD_110040: "110040", //타행이체
      CORP_BZWK_APRVALCD_110041: "110041", //타행이체 - 베트남 나파스
      CORP_BZWK_APRVALCD_110042: "110042", //타행이체 - 미얀마 CBM-NET2
      CORP_BZWK_APRVALCD_110050: "110050", //자동이체등록
      CORP_BZWK_APRVALCD_110051: "110051", //자동이체등록해지
      CORP_BZWK_APRVALCD_110052: "110052", //자동이체등록변경
      CORP_BZWK_APRVALCD_110070: "110070", //해외송금신청
      CORP_BZWK_APRVALCD_110071: "110071", //해외송금신청취소
      CORP_BZWK_APRVALCD_110080: "110080", //타행대량이체
      CORP_BZWK_APRVALCD_110081: "110081", //타행대량이체(신규)
      CORP_BZWK_APRVALCD_110082: "110082", //급여이체(미얀마)
      CORP_BZWK_APRVALCD_110090: "110090", //계좌간이체(통합)
      CORP_BZWK_APRVALCD_110030: "110030", //외화이체
      CORP_BZWK_APRVALCD_120010: "120010", //예금해지/갱신
      CORP_BZWK_APRVALCD_130010: "130010", //대출금상환
      CORP_BZWK_APRVALCD_110011: "110011", //PhoneTopup(베트남)
      CORP_BZWK_APRVALCD_110012: "110012", //BillPayment(베트남)
      CORP_BZWK_APRVALCD_140001: "140001", //사용자등록관리(등록)
      CORP_BZWK_APRVALCD_140002: "140002", //사용자등록관리(삭제)
      CORP_BZWK_APRVALCD_140003: "140003", //사용자등록관리(수정)
      CORP_BZWK_APRVALCD_140004: "140004", //결재단계설정/수정
      CORP_BZWK_APRVALCD_140005: "140005", //사용자별보안매체관리(해제)
      CORP_BZWK_APRVALCD_140006: "140006", //사용자별보안매체관리(등록/변경)

      PAGING_LINE_CNT: 10, //1페이지당 row수

      TRAN_DSTCD_1: "1", //결재할내역
      TRAN_DSTCD_2: "2", //결재진행내역
      TRAN_DSTCD_3: "3", //결재완료내역

      APRVAL_STATUS_CD: [
        { text: "1_결재상태구분", value: "1" },
        { text: "2_결재상태구분", value: "2" },
      ], //결재상태구분코드
      APRVAL_STATUS_CD2: [
        { text: "MCOM-0000061", value: "0" },
        { text: "PCOP-02-02-04-03", value: "1" },
        { text: "PCOP-02-02-03-10", value: "2" },
        { text: "PCOP-02-02-02-13", value: "3" },
      ], //결재상태구분코드

      //캘린더 옵션
      CALENDAR_SUBTRACT_FIVE_YEAR: "SUBTRACT_FIVE_YEAR", //-5년
      CALENDAR_SUBTRACT_TEN_YEAR: "SUBTRACT_TEN_YEAR", //-10년
      CALENDAR_ADD_TEN_YEAR: "ADD_TEN_YEAR", //+10년

      CALENDAR_RANGE_TODAY: 1, //Today
      CALENDAR_RANGE_1W: 2, //-1W
      CALENDAR_RANGE_1M: 3, //-1M
      CALENDAR_RANGE_3M: 4, //-3M
      CALENDAR_RANGE_6M: 5, //-6M
      CALENDAR_RANGE_12M: 7, //-12M
      CALENDAR_RANGE_1YEAR: 8, //1 Year ago
      CALENDAR_RANGE_2YEAR: 9, //2 Year ago
      CALENDAR_RANGE_3YEAR: 10, //3 Year ago
      CALENDAR_RANGE_4YEAR: 11, //4 Year ago
      CALENDAR_RANGE_ETC: 12, //별도 요청 시까지
      CALENDAR_RANGE_3M_AFTER: 13, //+3M
      CALENDAR_RANGE_6M_AFTER: 14, //+6M
      CALENDAR_RANGE_12M_AFTER: 15, //+12M

      PASSWORD_MIN_LENGTH: 6,
      PASSWORD_MAX_LENGTH: 12,

      //타행이체 송금처리구분코드
      OTR_TRASACTION_STATUS_NA: 1, //해당무
      OTR_TRASACTION_STATUS_APPLIED: 2, // 신청
      OTR_TRASACTION_STATUS_APPLICATION_CANCEL: 3, //신청취소
      OTR_TRASACTION_STATUS_ACCEPTED: 4, // 접수
      OTR_TRASACTION_STATUS_ACCEPTANCE_CANCEL: 5, //접수취소
      OTR_TRASACTION_STATUS_ACCEPTANCE_ERROR: 6, //접수오류
      OTR_TRASACTION_STATUS_REMITTANCE_COMPLETED: 7, //송금완료
      OTR_TRASACTION_STATUS_REMITTANCE_ERROR: 8, //송금오류

      //송금유형구분코드
      RMTANC_PTRN_DSTCD_01: "RTGS",
      RMTANC_PTRN_DSTCD_02: "NEFT",

      //메인 팝업 사이즈
      MAIN_POPUP_WIDTH: 600,
      MAIN_POPUP_HEIGHT: 540,

      //세션유지 시간(프론트)
      SESSION_TIME: 10,

      //validator
      VALIDATOR_REQUIRED: "required",
      VALIDATOR_MAXLENGTH: "maxlength",
      VALIDATOR_MINLENGTH: "minlength",
      VALIDATOR_FIXLENGTH: "fixlength",
      VALIDATOR_MAXBYTE: "maxByte",
      VALIDATOR_MINVALUE: "minValue",
      VALIDATOR_MAXVALUE: "maxValue",
      VALIDATOR_ALPHA: "alpha", //영어만
      VALIDATOR_ALPHANUM: "alphaNum", //영어, 숫자, 띄어쓰기
      VALIDATOR_ALPHANUM_ONLY: "alphaNumOnly", //영어, 숫자
      VALIDATOR_LOCALENUM: "localeNum", //한국어, 외국어, 숫자, 띄어쓰기
      VALIDATOR_NUMERIC: "numeric", //숫자
      VALIDATOR_NUMERICCOMMA: "numericComma", //숫자
      VALIDATOR_ENGCASE1: "engCase1", //영어, 숫자, 띄어쓰기, 특수문자 . - & ( ) / %
      VALIDATOR_ENGCASE2: "engCase2", //영어, 숫자, 띄어쓰기, 특수문자   -
      VALIDATOR_ENGCASE3: "engCase3", //영어, 숫자, 띄어쓰기, 특수문자 . - & ( ) /
      VALIDATOR_ENGCASE4: "engCase4", //영어, 숫자, 띄어쓰기, 특수문자 . -   ( ) /   , : +
      VALIDATOR_ENGCASE5: "engCase5", //영어, 숫자, 띄어쓰기, 특수문자 . - & ( ) /   , :
      VALIDATOR_ENGCASE6: "engCase6", //영어, 숫자, 띄어쓰기, 특수문자 . - & ( ) /   , : + ? ' { }
      VALIDATOR_ENGCASE7: "engCase7", //영어, 숫자, 띄어쓰기, 특수문자 , - ( )
      VALIDATOR_ENGCASE8: "engCase8", //영어, 숫자, 띄어쓰기, (키보드에 있는)특수문자
      VALIDATOR_LOCALECASE1: "localeCase1", //한국어, 외국어, 숫자, 특수문자 . - & ( ) / %
      VALIDATOR_LOCALECASE2: "localeCase2", //한국어, 외국어, 숫자, 띄어쓰기, 특수문자   -
      VALIDATOR_LOCALECASE3: "localeCase3", //한국어, 외국어, 숫자, 띄어쓰기, 특수문자 . - & ( ) /
      VALIDATOR_LOCALECASE4: "localeCase4", //한국어, 외국어, 숫자, 띄어쓰기, 특수문자 . -   ( ) /   , : +
      VALIDATOR_TOLOWERCASE: "toLowerCase", //소문자유지
      VALIDATOR_ALPHLOCALE_ONLY1: "alphaLocaleOnly1", //외국어, 숫자, 특수문자 . - & ( ) / %
      VALIDATOR_ALPHLOCALE_ONLY2: "alphaLocaleOnly2", //영어, 외국어
      VALIDATOR_ALPHLOCALE_ONLY3: "alphaLocaleOnly3", //영어, 숫자, 띄어쓰기, 특수문자 - /

      //Common Grid Type
      GRID_TYPE_SCROLL: "scroll", //스크롤 이벤트
      GRID_TYPE_TAG: "tag", //Tag 이벤트
      GRID_TYPE_ADDSEARCH: "addSearch", //추가 조회시
      GRID_TYPE_SEARCHBOX: "searchBox", //SearchBox 조건시

      //error type
      ERROR_NETWORK: "network",
      ERROR_FOR_MASTER: "forMater",
      ERROR_NOT_APPROVAL_LINE: "notApprovalLine",
      ERROR_NOT_QRPAYMENT_USER: "notQrPaymentUser",
      ERROR_SERVICE: "service",

      //market url
      MARKET_ANDROID: "market://details?id=com.kbstar.global",

      //나파스 메뉴 권한명
      ALLOW_MENU_NAPAS: "NAPAS",
      //타행대량이체 권한명
      ALLOW_MENU_BULK_OTRBNK: "BULK_OTRBNK",
      //CBMNET 권한명
      ALLOW_MENU_CBMNET2: "CBMNET2",
      //QR결제 권한명
      ALLOW_MENU_QRPAYMENT: "QRPAYMENT",
      //생체정보검증 권한명
      ALLOW_MENU_EKYC: "EKYC",
      //MMQR 권한명
      ALLOW_MENU_MMQR: "MMQR",

      //******** 국가별 분기 *********/
      //첫방문고객을 위한 안내
      VISITING_OGMMR: false,
      VISITING_OGCBD: true,
      VISITING_OGVTN: true,
      VISITING_OGIND: true,
      VISITING_OGAUC: true,
      VISITING_OGLD: true,
      VISITING_OGHK: false,

      //인터넷뱅킹 서비스절차
      APPLY_FOR_IB_OGMMR: true,
      APPLY_FOR_IB_OGCBD: true,
      APPLY_FOR_IB_OGVTN: true,
      APPLY_FOR_IB_OGIND: true,
      APPLY_FOR_IB_OGAUC: true,
      APPLY_FOR_IB_OGLD: true,
      APPLY_FOR_IB_OGHK: false,

      //사용자암호3회오류해제
      USER_CIPHER_3TM_ERR_REQ_KNOW_OGMMR: true,
      USER_CIPHER_3TM_ERR_REQ_KNOW_OGCBD: true,
      USER_CIPHER_3TM_ERR_REQ_KNOW_OGVTN: true,
      USER_CIPHER_3TM_ERR_REQ_KNOW_OGIND: true,
      USER_CIPHER_3TM_ERR_REQ_KNOW_OGAUC: true,
      USER_CIPHER_3TM_ERR_REQ_KNOW_OGLD: true,

      //로그인 푸터 FAQ section
      INTERNET_FAQ_OGMMR: true,
      INTERNET_FAQ_OGCBD: true,
      INTERNET_FAQ_OGVTN: true,
      INTERNET_FAQ_OGIND: false,
      INTERNET_FAQ_OGAUC: true,
      INTERNET_FAQ_OGLD: true,

      //공통 푸터 KB소개
      VISION_OGMMR: true,
      VISION_OGCBD: true,
      VISION_OGVTN: true,
      VISION_OGIND: false,
      VISION_OGLD: true,
      VISION_OGAUC: true,
      VISION_OGTK: true,
      VISION_OGHK: true,

      //공통 푸터 경영공시
      DISCLOSURE_OGMMR: false,
      DISCLOSURE_OGCBD: false,
      DISCLOSURE_OGVTN: false,
      DISCLOSURE_OGIND: false,
      DISCLOSURE_OGLD: false,
      DISCLOSURE_OGAUC: true,
      DISCLOSURE_OGTK: false,
      DISCLOSURE_OGHK: false,

      //공통 푸터 인터넷뱅킹이용약관
      TERMS_OGMMR: true,
      TERMS_OGCBD: true,
      TERMS_OGVTN: true,
      TERMS_OGIND: true,
      TERMS_OGLD: true,
      TERMS_OGAUC: true,
      TERMS_OGTK: false,
      TERMS_OGHK: false,

      //공통 푸터 개인정보보호정책
      PRIVACY_OGMMR: true,
      PRIVACY_OGCBD: true,
      PRIVACY_OGVTN: true,
      PRIVACY_OGIND: true,
      PRIVACY_OGLD: false,
      PRIVACY_OGAUC: true,
      PRIVACY_OGTK: false,
      PRIVACY_OGHK: false,

      //로그인 버튼
      LOGIN_OGMMR: true,
      LOGIN_OGCBD: true,
      LOGIN_OGVTN: true,
      LOGIN_OGIND: true,
      LOGIN_OGLD: true,
      LOGIN_OGAUC: true,
      LOGIN_OGTK: false,
      LOGIN_OGHK: false,

      SAVINGS_FAQ: "003", //예금FAQ
      LOAN_FAQ: "004", //대출FAQ
      REMITTANCE_FAQ: "005", //송금FAQ
      IMPORTEXPORT_FAQ: "006", //입출금FAQ
      INTERNETBANKING_FAQ: "007",

      SCURTY_DEVI_VNDR_NONE: "000", //해당무
      SCURTY_DEVI_VNDR_VASCO_TOKEN: "004", //바스코 TOKEN OTP
      SCURTY_DEVI_VNDR_VASCO_ADVANCED: "304", //바스코 ADVANCED OTP
      SCURTY_DEVI_VNDR_SSEN_MOTP: "701", //센스톤 mOTP

      MAX_FVRT_ACN_CNT: 3, //메인 내계좌 표기 개수

      //QR 단계별 검증 방법
      QR_VALIDATION_BASIC    : "BASIC",                 //BASIC 검증
      QR_VALIDATION_CRC      : "CRC",                   //CRC 검증
      QR_VALIDATION_BUSINESS : "BUSINESS",              //Business 검증
      QR_VALIDATION_SUCCESS  : "QR_VALIDATION_SUCCESS", //QR 검증 성공

      MMQR_GUID : "com.mmqrpay.www", //MMQR GUID

      //MMQR 진행상태구분
      MMQR_TRAN_PRGRS_1: "MPAY-07-01-01-32",
      MMQR_TRAN_PRGRS_3: "MPAY-07-01-01-33",
      MMQR_TRAN_PRGRS_4: "MPAY-07-01-01-34",
      MMQR_TRAN_PRGRS_5: "MPAY-07-01-01-35",
      MMQR_TRAN_PRGRS_6: "MPAY-07-01-01-36",
      MMQR_TRAN_PRGRS_7: "MPAY-07-01-01-37",
      MMQR_TRAN_PRGRS_9: "MPAY-07-01-01-63",

      //MMQR 결제구분
      MMQR_Pay_PRGRS_1: "MPAY-07-01-01-53",
      MMQR_Pay_PRGRS_3: "MPAY-07-01-01-54",
      MMQR_Pay_PRGRS_4: "MPAY-07-01-01-55",
    });
  },
};
